<template>
    <el-dialog
        ref="ExportExcelDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="project-export-excel-dialog ah-detail-dialog"
        top="5vh"
        @open="onOpen"
        @opened="onOpened"
        @close="onClose"
        @closed="onClosed"
    >
        <template slot="title">專案管理 Excel 匯出</template>
        <div class="export-excel-layout">
            <div class="setting-view">
                <div class="setting-content" ref="settingContent">
                    <el-form label-width="100px" label-position="top">
                        <div style="margin-bottom: 10px;">匯出欄位</div>
                        <el-form-item>
                            <div class="custom-settings">
                                <div class="field-group" v-for="group in groupedFields" :key="group.key">
                                    <div class="group-header">
                                        <el-checkbox
                                            :value="isGroupChecked(group.fields)"
                                            :indeterminate="isGroupIndeterminate(group.fields)"
                                            @change="onGroupChange(group.fields, $event)"
                                        >{{ group.label }}</el-checkbox>
                                    </div>
                                    <div class="group-items">
                                        <div class="item" v-for="field in group.fields" :key="field.key">
                                            <el-checkbox v-model="field.checked" @change="saveSettingsToLocalStorage">{{ field.label }}</el-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="actions" :class="{ 'is-scrollable': isSettingsScrollable }">
                    <el-button @click="onClose">取消</el-button>
                    <el-button
                        type="primary"
                        class="primary-action"
                        :disabled="isExporting || !hasCheckedField"
                        :loading="isExporting"
                        @click="onExport"
                    >{{ isExporting ? '匯出中...' : '匯出' }}</el-button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import PROJECT_EXPORT_FIELDS, { PROJECT_EXPORT_FIELD_GROUPS } from './ProjectExportFields';

export default {
    name: 'project-export-excel-dialog',
    props: {
        visible: { type: Boolean, default: false },
        isExporting: { type: Boolean, default: false },
    },
    data() {
        return {
            fields: PROJECT_EXPORT_FIELDS.map((f) => ({ ...f, checked: true })),
            isSettingsScrollable: false,
        };
    },
    computed: {
        hasCheckedField() {
            return this.fields.some((f) => f.checked);
        },
        groupedFields() {
            return PROJECT_EXPORT_FIELD_GROUPS.map((group) => ({
                ...group,
                fields: this.fields.filter((f) => f.group === group.key),
            }));
        },
    },
    methods: {
        onOpen() {
            this.loadSettingsFromLocalStorage();
        },
        onOpened() {
            this.checkSettingsScrollable();
            window.addEventListener('resize', this.checkSettingsScrollable);
        },
        onClose() {
            this.$emit('close');
        },
        onClosed() {
            window.removeEventListener('resize', this.checkSettingsScrollable);
        },
        checkSettingsScrollable() {
            const el = this.$refs.settingContent;
            this.isSettingsScrollable = !!el && el.scrollHeight > el.clientHeight;
        },
        onExport() {
            const selectedFieldKeys = this.fields.filter((f) => f.checked).map((f) => f.key);
            this.$emit('export', selectedFieldKeys);
        },
        isGroupChecked(groupFields) {
            return groupFields.every((f) => f.checked);
        },
        isGroupIndeterminate(groupFields) {
            return groupFields.some((f) => f.checked) && !groupFields.every((f) => f.checked);
        },
        onGroupChange(groupFields, value) {
            const groupKeys = groupFields.map((f) => f.key);
            this.fields.forEach((f, i) => {
                if (groupKeys.includes(f.key)) this.fields[i].checked = value;
            });
            this.saveSettingsToLocalStorage();
        },
        saveSettingsToLocalStorage() {
            this.fields.forEach((f) => {
                localStorage.setItem(`projectExportExcel-${f.key}`, f.checked);
            });
        },
        loadSettingsFromLocalStorage() {
            this.fields.forEach((f, i) => {
                const value = localStorage.getItem(`projectExportExcel-${f.key}`);
                if (value !== null) this.fields[i].checked = value === 'true';
            });
        },
    },
};
</script>
<style lang="scss">
.project-export-excel-dialog {
    >.el-dialog {
        width: 440px;

        @media (max-width: 520px) {
            width: 90%;
        }
    }

    .setting-view {
        display: flex;
        flex-direction: column;

        >.setting-content {
            padding: 20px 40px 30px;
            max-height: 450px;
            overflow-y: auto;
        }

        >.actions {
            padding: 20px 40px;
            text-align: right;

            &.is-scrollable {
                border-top: 1px solid #ebeef5;
            }
        }
    }

    .custom-settings {
        line-height: 180%;

        .field-group {
            margin-bottom: 12px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .group-header {
            font-weight: bold;
        }

        .group-items {
            margin-left: 25px;
        }
    }
}
</style>
